// extracted by mini-css-extract-plugin
export var resizer = "_hc-0";